import { remove } from 'diacritics'

/**
 * Lowercases or uppercases the given input, removes diacritics
 */
export const normalize = (str: string, mode: 'toLowerCase' | 'toUpperCase' = 'toLowerCase'): string => remove(str[mode]())
